import React from 'react';
import ContactHero from '../components/ContactHero';
import ContactFormSection from '../components/ContactFormSection';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      <ContactHero />
      <ContactFormSection />
    </div>
  );
};

export default Contact;
